import { Skeleton } from "../skeleton/Skeleton.Parts";

export const CheckboxSkeleton = () => (
  <Skeleton $width="1.5rem" $height="1.5rem" $display="block" />
);
